import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import {ko} from 'date-fns/locale';
import {DateRange} from 'react-date-range';
import {useEffect, useRef, useState} from 'react';
import {format} from 'date-fns';
import React from 'react';
import {useOutsideClick} from '@/components/main/common/hooks/useOutsideClick';

/**
 * SoopUiCalendar 컴포넌트
 * @desc 날짜 선택 가능한 캘린더
 * @param {Object} props - 컴포넌트의 props
 * @param {Object} props.dateRange - dateRange 시작, 종료일자
 * @param {string} props.dateRange.startDate - 시작일자
 * @param {string} props.dateRange.endDate - 종료일자
 * @param {Function} [props.handleDateRange] - 시작 종료일자 변경 실행 함수
 * @param {Function} [props.handleCalendarClosed] - 캘린더 닫는 실행 함수
 * @param {Function} [props.handleApplyStatus] - 적용버튼 클릭 시 실행 함수
 * @returns {JSX.Element} 캘린더 렌더링하는 JSX 요소
 // TODO example 요소 추가하기
 **/
const SoopUiCalendar = ({
  dateRange,
  isDateRangeSelected,
  handleDateRange,
  handleCalendarClosed,
  handleApplyStatus,
  handleRangeFocusChange,
  handleDateSelected,
}) => {
  const [isActive, setIsActive] = useState(false); //적용버튼 활성화 유무
  const [shownDate, setShownDate] = useState(new Date());

  const isSelectedStart = isDateRangeSelected[0] === 0;
  const isSelectedEnd = isDateRangeSelected[1] === 0;

  const dateLayer = useRef(null);

  // 시작일, 종료일 선택 시 실행되는 콜백 함수
  const handleDateChanged = (range) => {
    const {startDate, endDate, key} = range.selection;

    const updatedDateRange = {
      startDate: format(startDate, 'yyyy-MM-dd'),
      endDate: format(endDate, 'yyyy-MM-dd'),
      key: key,
      applyStatus: true,
    };

    handleDateRange([updatedDateRange]);
  };

  useEffect(() => {
    const formattedDate = {
      startDate: format(new Date(), 'yyyy-MM-dd'),
      endDate: format(new Date(), 'yyyy-MM-dd'),
      key: 'selection',
      applyStatus: false,
    };
    handleDateRange([formattedDate]);
  }, []);

  // 아래 코드처럼 변경하면 사용자가 기간을 선택하고 캘린더를 닫은 후 다시 캘린더를 열었을 때 선택된 기간으로 캘린더에 표시가 되어있음
  // 현재는 기간이 선택되어져 있어도 캘릭더를 다시 열었을 때 오늘날짜만 선택되어져있음. ( 기존 정책이였던걸로 )
  // TODO: 정책 변경돼서 캘린더 재오픈시 선택된 기간 표시해달라고하면 아래 코드 사용
  // useEffect(() => {
  //   const createDateRange = (start, end) => ({
  //     startDate: format(start, 'yyyy-MM-dd'),
  //     endDate: format(end, 'yyyy-MM-dd'),
  //     key: 'selection',
  //     applyStatus: false,
  //   });

  //   const today = new Date();
  //   const initialDateRange = dateRange[0].startDate
  //     ? createDateRange(dateRange[0].startDate, dateRange[0].endDate)
  //     : createDateRange(today, today);

  //   handleDateRange([initialDateRange]);
  // }, []);

  useEffect(() => {
    getHiddenButton(dateRange[0].endDate);
    getHiddenButton(dateRange[0].startDate);
  }, [dateRange]);

  const getHiddenButton = (date = new Date()) => {
    const nextButtonClass = document.querySelector('.rdrNextButton').classList;
    const prevButtonClass = document.querySelector('.rdrPprevButton').classList;

    if (date) {
      const [shownYear, shownMonth] = format(date, 'yyyy-MM-dd').split('-');
      const currentYear = new Date().getFullYear().toString();
      shownYear === currentYear && shownMonth === '12'
        ? nextButtonClass.add('rdrButtonHide')
        : nextButtonClass.remove('rdrButtonHide');
      shownYear === '2007' && shownMonth === '01'
        ? prevButtonClass.add('rdrButtonHide')
        : prevButtonClass.remove('rdrButtonHide');
    }
  };

  const handleClick = (range) => {
    handleDateSelected({
      startDate: dateRange[0].startDate,
      endDate: dateRange[0].endDate,
    });
    handleApplyStatus(true);
    handleCalendarClosed();
  };

  const disableFutureDates = (date) => {
    return date > new Date(); // 오늘 이후의 날짜를 비활성화
  };

  useOutsideClick(dateLayer, () => {
    handleCalendarClosed();
  });

  useEffect(() => {
    setIsActive(isSelectedStart && isSelectedEnd);
    if (isSelectedStart && isSelectedEnd) {
      getHiddenButton(dateRange[0].startDate);
    }
  }, [isDateRangeSelected]);

  return (
    <>
      {
        <div className='date_layer' ref={dateLayer}>
          <DateRange
            locale={ko}
            editableDateInputs={true}
            onChange={(range) => handleDateChanged(range)}
            moveRangeOnFirstSelection={false}
            ranges={dateRange}
            disabledDay={disableFutureDates}
            minDate={new Date(2007, 0, 1)}
            maxDate={new Date(new Date().getFullYear(), 11, 31)}
            rangeColors={['#0182FF', '#0182FF']} // 두 가지 색상 지정
            focusedRange={isDateRangeSelected} // 포커스 상태를 수동으로 설정
            onRangeFocusChange={(newFocusedRange) => {
              handleRangeFocusChange(newFocusedRange);
            }} // 포커스 변경 시 호출되는 핸들러
            shownDate={shownDate}
            onShownDateChange={(date) => {
              setShownDate(date);
              getHiddenButton(date);
            }}
          />
          <div className='btn_submit'>
            <button type='button' onClick={handleClick} disabled={!isActive}>
              적용
            </button>
          </div>
        </div>
      }
    </>
  );
};

export default React.memo(SoopUiCalendar);
